import { render, staticRenderFns } from "./markingsMsgList.vue?vue&type=template&id=00ccde41&scoped=true"
import script from "./markingsMsgList.vue?vue&type=script&lang=js"
export * from "./markingsMsgList.vue?vue&type=script&lang=js"
import style0 from "./markingsMsgList.vue?vue&type=style&index=0&id=00ccde41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ccde41",
  null
  
)

export default component.exports